<div class="accordion custom-accordion user-list">
    @for (user of users; track user; let userIndex = $index) {
    <div class="card mb-0">
        <div class="my-1 ml-1 userRoles rounded align-items-center">
            <!-- <h5 class="m-0 font-weight-light"> -->
            <!-- accordion button -->
            <a data-toggle="collapse" class="btn btn-xs btn-light" href="#collapseFour_{{userIndex}}"
                aria-expanded="true">
                <span class="mdi mdi-chevron-down"></span>
            </a>
            <span class="ml-1">{{user.firstName}} {{user.lastName}} ({{user.email}})</span>
            @if (security.permitted('security', 'roles users', 'add')) {
            <button type="button" class="ml-2 btn btn-xs btn-primary shadow" data-toggle="modal"
                data-target="#bs-example-modal-sm" (click)="selectUser(user.id,0,user.roles,userIndex)">
                <span class="uil-plus text-white"></span> {{ words[language][ 'addRemoveRoles' ] }}
            </button>
            }
        </div>
        <div id="collapseFour_{{userIndex}}" class="collapse show p-0" aria-labelledby="headingFour">
            <!-- <div > -->
            <!-- accordion roles -->
            <div class="list-group p-1 bg-transparent border-top">
                @for (role of user.relationship; track role; let relationshipIndex = $index) {
                <div type="button" class=" d-flex row userRoles rounded">
                    <div class="col-md-4 d-flex align-items-center">
                        {{role.roleName}}
                        @if (security.permitted('security', 'roles users', 'delete') && !user.currentUser) {
                        <span class="uil-trash-alt pl-2 text-danger" (click)="deleteRole(user.id,role.roleId,role)"></span>
                        }
                    </div>
                    <div class="col-md-8 d-flex flex-wrap align-items-center">
                        @if (role.lots==null || role.lots.length==0) {
                        <button class="btn btn-xs btn-light m-1">
                            <small>All</small>
                        </button>
                        }
                        <!-- places button -->
                        @for (lot of role.lots; track lot; let lotIndex = $index) {
                        <button type="button" class="btn btn-xs btn-light m-1">
                            <small>{{lot.name}}</small>
                            @if (security.permitted('security', 'roles users', 'delete') && !user.currentUser) {
                            <span class="uil-trash-alt pl-2 text-danger"
                                (click)="deleteLot(lot.id, user.id, role.roleId, userIndex, relationshipIndex, lotIndex)"></span>
                            }
                        </button>
                        }
                        <!-- add button -->
                        @if (security.permitted('security', 'roles users', 'add')) {
                        <button (click)="selectUser(user.id, role.roleId, user.roles,userIndex)" type="button" class="btn btn-xs btn-light m-1">
                            <span class="uil-plus"></span>{{ words[language][ 'chooseLot' ] }}
                        </button>
                        }
                        <!-- select -->
                        @if (userIndex==userSelected.index && role.roleId==userSelected.roleId) {
                        <select class="form-control select2 btn-xs w-25" data-toggle="select2" [(ngModel)]="lotId" (change)="addLot(userSelected.userId, userSelected.roleId)">
                            <option value="0" disabled>{{ words[language][ 'select' ] }}</option>
                            @for (dealership of corporation.dealerships; track dealership) {
                            <optgroup [label]="dealership.contact.companyName">
                                @for (lot of dealership.lots; track lot) {
                                <option [value]="lot.id">{{lot.contact.companyName}}</option>
                                }
                            </optgroup>
                            }
                        </select>
                        }
                        <!-- select -->
                    </div>
                </div>
                }
            </div>
            <!-- </div> -->
        </div>
    </div>
    }
</div>

<!-- modals section -->
<div class="modal fade" id="bs-example-modal-sm" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">{{ words[language][ 'addRemoveRoles' ] }}</h4>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="modal-body p-0">
                <ul class="list-group text-dark">
                    @for (role of userSelected.roles; track role.id; let i = $index) {
                    <li class="list-group-item d-flex align-items-center border-0">
                        <input id="roleName_{{role.id}}" type="checkbox" [checked]="role.checked" class="mr-2" (change)="toggleRole(userSelected.userId, role.id,role.checked,i,role,$event)">
                        <button type="button" class="border-0" aria-label="roleName">{{role.name}}</button>
                    </li>
                    }
                </ul>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
